/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-globals */
import '../../css/frontend/style.css';
import { CountUp } from 'countup.js';
import { doc } from 'prettier';
import PromoModalController from './components/promoModalController';
import Accordion from './components/accordion';
import ReadyToLearnMoreForm from './forms/ReadyToLearnMoreForm';
import LightBoxForm from './forms/LightBoxForm';

const $ = require('jquery');

$('document').ready(function () {
	if (sessionStorage.fontsLoaded) {
		document.documentElement.classList.add('fonts-loaded');
	} else if ('fonts' in document) {
		Promise.all([
			document.fonts.load('700 1em filsonpro'),
			document.fonts.load('800 1em filsonpro'),
		]).then(() => {
			document.documentElement.classList.add('fonts-loaded');
		});
	}

	setTimeout(function () {
		$('.cta__button, .stride-button, .menu-button a, .header__cta-link, .banner-link') // prettier-ignore
			.click(function (event) {
				const $this = $(this);

				if ($this.attr('href') && $this.attr('href') === `#schedule-a-call`) {
					event.preventDefault();
					// eslint-disable-next-line no-undef
					const lightBoxForm = new LightBoxForm();
					lightBoxForm.init();
					// eslint-disable-next-line no-undef
					lity('#schedule-a-call', );
				}
			}); // prettier-ignore
	}, 0);

	const flipCardControls = $('.flip-card__button--back');
	if (flipCardControls.length > -1) {
		$('.flip-card__button--back').click(function () {
			$(this).closest('.flip-card').toggleClass('flip-card--active');
		});
	}

	const footerMenuItem = document.querySelectorAll('footer .menu-item-has-children');

	if (footerMenuItem.length > 0) {
		footerMenuItem.forEach(function (item) {
			item.addEventListener('click', function (e) {
				if (window.innerWidth < 993) {
					const menuOpened = item.classList.contains('is-active');
					if (!menuOpened) {
						e.preventDefault();
						item.classList.toggle('is-active');
					}
				}
			});
		});
	}

	const footerMenuItemArrow = document.querySelectorAll('footer .menu-item-toggle');
	if (footerMenuItemArrow.length > 0) {
		footerMenuItemArrow.forEach(function (item) {
			if (window.innerWidth < 993) {
				item.addEventListener('click', function (e) {
					e.preventDefault();
					e.stopPropagation();
					item.parentElement.parentElement.parentElement.classList.toggle('is-active');
				});
			}
		});
	}

	setTimeout(function () {
		const statistics = document.querySelectorAll('.statistics__stats');
		if (statistics.length > 0) {
			const stats = document.querySelectorAll('.statistics__number');
			stats.forEach(function (item) {
				const countOptions = {
					enableScrollSpy: true,
					scrollSpyDelay: 200,
					scrollSpyOnce: true,
				};
				const countUp = new CountUp(item, item.dataset.endcount, countOptions);
			});
		}
	}, 1000);

	setTimeout(function () {
		const trustedByStats = document.querySelectorAll('.trusted-by__stats-container');
		if (trustedByStats.length > 0) {
			const stats = document.querySelectorAll('.trusted-by__stat-number');
			stats.forEach(function (item) {
				const countOptions = {
					enableScrollSpy: true,
					scrollSpyDelay: 200,
					scrollSpyOnce: true,
				};
				const countUp = new CountUp(item, item.dataset.endcount, countOptions);
			});
		}
	}, 1000);

	const customQuote = document.querySelectorAll('.js-custom-quote');
	if (customQuote.length > 0) {
		$('.js-custom-quote-submit').on('click', function (e) {
			const $this = $(this);
			const $parentContainer = $this.closest('.js-custom-quote');
			if (!$parentContainer.find(":checkbox[name='issues[]']").is(':checked')) {
				e.preventDefault();
				$parentContainer.find('.js-error-message').show();
				$('.custom-quote__issue ').on('click', function () {
					$('.custom-quote__issue ').off('click');
					$parentContainer.find('.js-error-message').hide();
				});
			}
		});
	}

	const tabs = $('.stride-tabs');
	if (tabs.length > 0) {
		$('.stride-tabs__link').click(function (event) {
			event.preventDefault();
			const $this = $(this);
			const target = $this.attr('data-tab');
			const tabContainer = $this.closest('.stride-tabs');
			const tabPosition = tabContainer.offset().top;
			$('html, body').animate(
				{
					scrollTop: tabPosition - 100,
				},
				500,
			);

			$this.addClass('stride-tabs__link--active');
			$this.siblings().removeClass('stride-tabs__link--active');

			tabContainer.find(`.stride-tabs__content`).removeClass('stride-tabs__content--active');

			tabContainer
				.find(`.stride-tabs__content[data-tab-content="${target}"`)
				.addClass('stride-tabs__content--active');
		});

		// eslint-disable-next-line no-undef
		const headerHeight = $('.header').height();
		let adminBarHeight = 0;
		if ($('body').hasClass('admin-bar')) {
			adminBarHeight = $('#wpadminbar').height();
		}

		$('.stride-tabs').each(function () {
			const id = $(this).attr('id');
			// eslint-disable-next-line no-undef
			const sticky = new Sticky(`#${id} .stride-tabs__navigation`, {
				marginTop: headerHeight + adminBarHeight,
			});
		});
	}

	const header = $('header');
	if (header.hasClass('bg-transparent-white') || header.hasClass('bg-transparent-blue')) {
		let headerTransparencyOn = true;
		document.addEventListener('scroll', function () {
			if (headerTransparencyOn && scrollY > 20) {
				header.addClass('scrolled');
				headerTransparencyOn = false;
			} else if (!headerTransparencyOn && scrollY < 20) {
				headerTransparencyOn = true;
				header.removeClass('scrolled');
			}
		});
	}

	$('.mega-menu-toggle').on('click', function () {
		if ($(this).hasClass('mega-menu-open')) {
			$('header').removeClass('hamburger-opened');
		} else {
			$('header').addClass('hamburger-opened');
		}
	});

	const accordions = document.querySelectorAll('.single-faq');
	accordions.forEach((accordionEl) => {
		new Accordion(accordionEl);
	});

	// Used by Sticky Footer Block
	const copyToClipboardButton = document.querySelectorAll('.js-sticky-footer-share-button');
	if (copyToClipboardButton.length > 0) {
		copyToClipboardButton.forEach(function (item) {
			const notificationButton = document.querySelectorAll('.sticky_footer__notification-button'); // prettier-ignore
			item.addEventListener('click', function (e) {
				e.preventDefault();
				notificationButton[0].classList.add('active');
				const textarea = document.createElement('textarea');
				document.body.appendChild(textarea);
				textarea.value = window.location.href; // current URL
				textarea.select();
				document.execCommand('copy');
				document.body.removeChild(textarea);
			});
		});
	}

	// Adding dataLayer variable when Play button is clicked
	const stridePlay = document.querySelectorAll('.stride-play');
	if (stridePlay.length > 0) {
		stridePlay.forEach(function (item) {
			item.addEventListener('click', function () {
				const videoLink = item.href;
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					event: 'Video Opened',
					videoLink,
				});
			});
		});
	}
	// If banner is shown the space is added above the header
	const banner = document.querySelector('.js-top-banner');
	if (banner) {
		banner.parentElement.parentElement.classList.add('banner--shown');

		window.addEventListener('resize', function () {
			const bannerText = document.querySelectorAll('.banner__text p, .banner-link');
			let fontSize;
			if (window.innerWidth < 1040) {
				fontSize = 12;
			} else {
				fontSize = 16;
			}

			bannerText.forEach(function (item) {
				item.style.fontSize = `${fontSize} px`;
			});
		});
	}

	const readyToLearnMoreForm = $('.sticky-cta-form');
	if (readyToLearnMoreForm.length > 0) {
		const readyToLearnMoreForm = new ReadyToLearnMoreForm();
		readyToLearnMoreForm.init();
		$('.sticky-cta-form__teaser').click(function () {
			$(this).closest('.sticky-cta-form').toggleClass('form-active');
		});
	}

	const promoModal = $('#promo-modal');
	if (promoModal.length > 0) {
		const promoModalController = new PromoModalController();
		promoModalController.init();
	}
});
